import React from 'react';
import CardsContent from "./cards-content.jsx";
import TableContent from "./table-content.jsx";

const ReportContent = ({ data, collapsed, tableColumns }) => {
    return (
        <>
            <CardsContent key={`cards-${collapsed}`} data={data}/>
            <TableContent key={`table-${collapsed}`} data={data} tableColumns={tableColumns}/>

            <div id="chart-tables"/>
        </>
    );
};

export default ReportContent;